import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

import { DefaultHeaderCell, NonSortableHeaderCell } from "../../../../Layout/SortedList";

export default class ListHeader extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    sort: PropTypes.object
  };

  static defaultProps = {
    isMobile: false,
    sort: {}
  };

  handleClick = keyName => this.props.onClick(keyName);

  renderStatusTooltip = () => {
    return (
      <Fragment>
        <p className="list-status__description">{i18n.t("tooltip.possibleStatus")}</p>
        <p className="list-status__label --green">{i18n.t(`loads.status.OnTime`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.onTime")}</p>
        <p className="list-status__label --red">{i18n.t(`loads.status.Delayed`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.delayed")}</p>
        <p className="list-status__label --blue">{i18n.t(`loads.status.Delivered`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.delivered")}</p>
        <p className="list-status__label --grey">{i18n.t(`loads.status.ToBeScheduled`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.toBeScheduled")}</p>
      </Fragment>
    );
  };

  renderShipmentStatusTooltip = () => {
    return (
      <Fragment>
        <p className="list-status__description">{i18n.t("tooltip.possibleShipmentStatus")}</p>
        <p className="list-status__label">{i18n.t(`loads.shipmentStatuses.ToBeConfirmed`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.toBeConfirmed")}</p>
        <p className="list-status__label">{i18n.t(`loads.shipmentStatuses.Estimated`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.estimated")}</p>
        <p className="list-status__label">{i18n.t(`loads.shipmentStatuses.Booked`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.booked")}</p>
        <p className="list-status__label">{i18n.t(`loads.shipmentStatuses.DeliveryNotConfirmed`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.deliveryNotConfirmed")}</p>
        <p className="list-status__label">{i18n.t(`loads.shipmentStatuses.Arrived`)}</p>
        <p className="list-status__description">{i18n.t("tooltip.arrived")}</p>
      </Fragment>
    );
  };

  render() {
    return (
      <div role="row" tabIndex="0" className="sorted-list__row-header">
        <DefaultHeaderCell
          className="--first --x4"
          keyName="loadId"
          label={`${i18n.t("loads.load")} # - ${i18n.t("loads.mill")}`}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x3"
          keyName="loadStatus.statusValue"
          label={i18n.t("loads.deliveryStatus")}
          tooltipContent={this.renderStatusTooltip}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x3"
          keyName="quantityPlanned.value"
          label={i18n.t("loads.planning")}
          tooltipContent={i18n.t("tooltip.planning")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="quantityProduced.value"
          label={i18n.t("loads.produced")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="quantityShipped.value"
          label={i18n.t("loads.shipped")}
          tooltipContent={i18n.t("tooltip.shipped")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x3"
          keyName="deliveryInfo"
          label={i18n.t("loads.shipmentStatus")}
          tooltipContent={this.renderShipmentStatusTooltip}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        {!this.props.isMobile && (
          <Fragment>
            <NonSortableHeaderCell className="--x1" keyName="deliveredDate" />
            <NonSortableHeaderCell className="--x1" keyName="arrow" />
          </Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/List/Loads/ListHeader.js